import { Autocomplete } from '@mui/material';

import { styled } from 'helpers';

const TimePickerAutocomplete = styled(Autocomplete)`
  .MuiInputBase-root {
    padding: 0;

    input.MuiInputBase-input {
      padding-right: 29px;
      padding-left: 16px;
    }
  }
  .MuiInputAdornment-root {
    cursor: pointer;
    position: absolute;
    right: 0;
  }
`;

export { TimePickerAutocomplete };
